<p class="text-4 text-secondary">@ {{ today | date: 'yyyy' }} Hill Tech Works</p>
<div class="footer-contact">
  <a href="tel:+18656038528" class="text-4 text-secondary">865-603-8528</a>
  <a href="mailto:info@hilltechworks.com" class="text-4 text-secondary">info@hilltechworks.com</a>
</div>
